import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for spline chart */
//   data: [],
//   /* Set additional options for spline chart. */
//   options: {},
//   /* Theme of the spline chart. */
//   theme: string,
// };

export default function Spline(props) {
  const { className, data, options, ...otherProps } = props;

  return (
    <BaseChart
      className={className}
      chartType="spline"
      data={data}
      options={options}
      {...otherProps}
    />
  );
}
